import React from 'react';
import Fade from 'react-reveal/Fade';
//TODO: Move processes to child components
const HomeProcess = () => (
    <section className="section-c section-5">
        <div className="section-title">
            <h2>Process</h2>
        </div>
        <div className="section-wrapper">
            <Fade>
                <div className="animated process">
                    <div className="process-icon">
                        <i className="fa fa-book fa-2x" aria-hidden="true"></i>
                    </div>
                    <div className="process-title">
                        Vision
                  </div>
                    <p>
                        Work close with the customer to understand their requirements - Which is the purpose of the product? Who is the target audience?
                </p>
                </div>
            </Fade>
            <Fade delay={200}>
                <div className="animated process">
                    <div className="process-icon">
                        <i className="fa fa-lightbulb-o fa-2x" aria-hidden="true"></i>
                    </div>
                    <div className="process-title">
                        Brainstorm
              </div>
                    <p>
                        Research tools, methods, industry standards and competition in order to find the best soltuion to achieve the desired goals.
              </p>
                </div>
            </Fade>
            <Fade delay={400}>
                <div className="animated process">
                    <div className="process-icon">
                        <i className="fa fa-paint-brush fa-2x" aria-hidden="true"></i>
                    </div>
                    <div className="process-title">
                        Design
              </div>
                    <p>
                        Turn the idea into an appealing interface design, while also striving for maximizing the user experience.
              </p>
                </div>
            </Fade>
            <Fade delay={600}>
                <div className="animated process">
                    <div className="process-icon">
                        <i className="fa fa-code fa-2x" aria-hidden="true"></i>
                    </div>
                    <div className="process-title">
                        Code
              </div>
                    <p>
                        The technical step which involves writing and delivering highly efficient and maintanable code.
              </p>
                </div>
            </Fade>
        </div>
    </section>
);

export default HomeProcess;


// WEBPACK FOOTER //
// ./src/components/home/Process/index.js